export default __webpack_public_path__ + "locales/zh-CN/People.json?hash=b7b494e5ca891f6727000e03aa7d2097";